<template>
  <div class="no-locations-container">
    <v-icon class="no-locations-icon" :color="iconColor" :size="iconSize">{{ icon }}</v-icon>
    <h3 class="no-locations-title">{{ title }}</h3>
    <p class="no-locations-text">{{ message }}</p>
    <v-btn
      v-if="showAction"
      :color="actionButtonColor"
      @click.stop="handleAction"
      rounded
      class="mt-4"
    >
      <v-icon left>mdi-google</v-icon>
      {{ actionText }}
    </v-btn>
    <slot></slot>
  </div>
</template>

<script>
import connectedAppsMixins from "@/mixins/connected.apps.mixins";

export default {
  name: "NoLocationsConnected",
  mixins: [connectedAppsMixins],
  props: {
    title: {
      type: String,
      default: "No Google Business Locations Connected"
    },
    message: {
      type: String,
      default: "Connect your Google Business Profile to manage your locations"
    },
    icon: {
      type: String,
      default: "mdi-google-my-business"
    },
    iconColor: {
      type: String,
      default: "amber darken-2"
    },
    iconSize: {
      type: [Number, String],
      default: 48
    },
    showAction: {
      type: Boolean,
      default: true
    },
    actionText: {
      type: String,
      default: "Connect Location"
    },
    actionRoute: {
      type: [String, Object],
      default: "/connected-apps"
    },
    actionButtonColor: {
      type: String,
      default: "primary"
    },
    useOAuth: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleAction(event) {
      // Prevent the event from propagating to parent handlers
      event.stopPropagation();
      
      if (this.useOAuth) {
        try {
          this.$emit('connect');
          this.$snackbar && this.$snackbar.show("Please wait a moment");
          
          // Only call initConnection directly if this component is used standalone
          // without a parent handler
          if (!this.$listeners || !this.$listeners.click) {
            this.initConnection("google_business_profile", "bulk");
          }
        } catch (error) {
          console.error("Error connecting Google Business Profile:", error);
          this.$alert && this.$alert.show("Failed to start Google Business connection. Please try again.");
        }
      } else {
        // Use the traditional route navigation for backward compatibility
        this.$router.push(this.actionRoute);
      }
    }
  }
};
</script>

<style scoped>
.no-locations-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  min-height: 250px;
  text-align: center;
}

.no-locations-icon {
  margin-bottom: 1.5rem;
}

.no-locations-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: rgba(0, 0, 0, 0.8);
}

.no-locations-text {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.6);
  max-width: 450px;
  margin-bottom: 1rem;
}
</style> 